(ns pfo.util (:require
              #_:clj-kondo/ignore [taoensso.timbre :as timbre
                                   :refer [trace debug info warn error fatal report logf
                                           tracef debugf infof warnf errorf fatalf reportf spy]]
              [clojure.data]
              [clojure.string :as str]
              [clojure.set :as set]
              [cljs-uuid-utils.core :as uuid]
              [goog.string :as gstring]
              [goog.crypt.base64 :as gbase64]
              [clojure.tools.reader.edn :as edn]
              [clojure.walk :refer [postwalk]]
              [reagent.core :as reagent]
              [linked.core :as linked]
              [cemerick.url :as cemerick]
              [cljs.pprint]
              [cljs.test :refer-macros [deftest is testing run-tests]]
              [cljs-time.coerce :as time-coerce]
              [cljs-time.core :as time-core]
              [decimal.core :as dc]
              [promesa.core :as p]
              [goog.string.linkify :as goog-linkify]
              [goog.i18n.NumberFormat.Format]
              [cljs-time.format :as time-format]
              [goog.dom :as gdom]
              [goog.dom.classlist :as gclasslist]
              [pfo.state :as state]))

;; Sets page (a reagent component) as a currently displayed page
;; (within page context -- header, footer, etc.)
(defn set-page [& page-args]
  (reset! state/current-page (vec page-args)))

(defn set-page-with-meta [metadata & page-args]
  (reset! state/current-page (with-meta (vec page-args) metadata)))

(defn set-location
  "Sets browser window location to given URL."
  [location]
  (set! (.-href (.-location js/window)) location))

;; Like set-page, but sets the page only if there's no current page
(def set-initial-page
  ^{:deprecated "No longer necessery when used with empty-page -- current page initialized with [:div]"}
  (fn [& page-args]
    (when-not @state/current-page
      (apply set-page page-args))))

(def url-encode cemerick/url-encode)

(defn get-token []
  (cemerick/url (-> js/window .-location .-href)))

;; Use this to put html entities such as &nbsp; into
;; Hiccup HTML structure.
(defn entity [string] (gstring/unescapeEntities string))

(def american-date-formatter (time-format/formatter "M/d/yy"))
(def american-full-year-date-formatter (time-format/formatter "M/d/yyyy"))
(def iso-date-formatter (time-format/formatters :date))

;; Format a datetime object as YYYY-MM-DD
(defn date-format-simple [datetime]
  (time-format/unparse american-date-formatter datetime))

(defn date-format-full-year [datetime]
  (time-format/unparse american-full-year-date-formatter datetime))

(def datetime-formatters (mapv time-format/formatter
                               ["yyyy-MM-dd'T'HH:mm:ssZZ"
                                "yyyy-MM-dd'T'HH:mm:ss.SSSZZ"
                                "yyyy-MM-dd'T'HH:mm:ss.SZZ"
                                "yyyy-MM-dd'T'HH:mm:ss"
                                "yyyy-MM-dd"]))
;; Parse a string representing a date/time. Returns nil
;; when format not is not recognized.
(defn parse-datetime [datetime-string]
  (if-let [result (time-format/parse datetime-string)]
    result
    (let [datetime-string (clojure.string/replace datetime-string #"\.\d+" "")]
      (first (for [f datetime-formatters
                   :let [d (try (time-format/parse f datetime-string) (catch :default _))]
                   :when d] d)))))

(defn parse-datetime-local [datetime-string]
  (if-let [result (time-format/parse-local datetime-string)]
    result
    (first (for [f datetime-formatters
                 :let [d (try (time-format/parse-local f datetime-string) (catch :default _))]
                 :when d] d))))

;; A round trip from date/time string to a date string
;; as returned by date-format-simple.
(defn date-reformat
  ([datetime-string formatting-func] (formatting-func (parse-datetime datetime-string)))
  ([datetime-string] (date-reformat datetime-string date-format-simple)))

(defn date-string
  "Round trip from a string representing date time to a string representing date"
  [datetime-string]
  (time-format/unparse iso-date-formatter (parse-datetime datetime-string)))

(defn date-format-hour-minute [datetime]
  (time-format/unparse (time-format/formatter "h:mma") datetime))

(defn date-format-date-hour-minute [datetime]
  (time-format/unparse (time-format/formatter "M/d/yyyy h:mm a") datetime))

;; Converts newlines to <br></br>.
(defn linebreaks [text]
  (gstring/newLineToBr (clojure.string/trim text)))

;; Inserts raw HTML into an element (e.g. :div).
;; Use to avoid escaping.
(defn html-elem [elem content]
  [elem {:dangerouslySetInnerHTML (reagent/unsafe-html content)}])

;; Does event.preventDefault(). Use for standard on-click handlers.
(defn handler [func]
  (fn [event] (func) (.preventDefault event)))

(defn plain-click?
  "True for a click the app may answer itself. A modified click is the user asking the
  browser for something of their own -- a new tab, a window, a saved target -- so it has
  to be left alone, and a link that swallows it lies about being a link."
  [event]
  (and (= 0 (.-button event))
       (not (.-metaKey event))
       (not (.-ctrlKey event))
       (not (.-shiftKey event))
       (not (.-altKey event))))

(defn event-value [event]
  (-> event .-target .-value))

(defn reset-from-event [atm]
  (fn [event]
    (reset! atm (event-value event))))

(defn swap-from-event [atm func & args]
  (fn [event]
    (apply swap! atm func (concat args (list (event-value event))))))

(defn remove-nil-values [ahash]
  (filter (fn [[_ v]] (some? v)) ahash))

(defn str->int [string]
  (js/parseInt string 10))

(defn somestr-to-int [string]
  (some-> string (str->int)))

;; http://stackoverflow.com/a/18319708
(defn vec-remove
  "remove elem in coll"
  [coll pos]
  (vec (concat (subvec coll 0 pos) (subvec coll (inc pos)))))

(defn vec-insert [coll pos item]
  (vec (concat (subvec coll 0 pos) [item] (subvec coll pos))))

(defn vec-replace [coll pos item]
  (assoc coll pos item))

;; http://stackoverflow.com/a/3249777
(defn in?
  "true if coll contains elm"
  [coll elm]
  (some #(= elm %) coll))

(defn make-params
  "create a=param&list=1 from a hash -- for cases that cljs-ajax handles the wrong way (e.g. arrays)"
  [params]
  (clojure.string/join "&" (mapv (fn [[k v]]
                                   (if (vector? v)
                                     (make-params (mapv #(identity [k %1]) v))
                                     (str (name k) "=" (url-encode v))))
                                 (filterv (fn [[_ v]]
                                            (or (not (vector? v)) (not-empty v))) params))))

(deftest test-make-params
  (is (= "ala=ma&kota=5&kota=7&kota=9&brzmi=wtrzcinie"
         (make-params {:ala "ma"
                       :kota [5 7 9]
                       :troche []
                       :brzmi "wtrzcinie"}))))

(defn- make-params-internal [data path-prefix url-encode-fn]
  (cond
    (map? data)
    (mapcat (fn [[k v]]
              (let [new-key-part (if (keyword? k) (name k) (str k))
                    ;; Check if the current path-prefix ends with an index, e.g., "signers[0]"
                    is-map-after-vector-index? (and (not (empty? path-prefix))
                                                    (re-matches #".*\[\d+\]$" path-prefix))
                    new-path (if is-map-after-vector-index?
                               (str path-prefix "." new-key-part) ; Format as "prefix[idx].key"
                               (if (empty? path-prefix)
                                 new-key-part
                                 (str path-prefix "[" new-key-part "]")))] ; Standard format "prefix[key]"
                (make-params-internal v new-path url-encode-fn)))
            data)

    (vector? data)
    (if (empty? data)
      []
      (if (every? #(not (or (map? %) (vector? %))) data) ; Vector of simple values
        (mapv #(str path-prefix "=" (url-encode-fn %)) data)
        ;; Vector of maps/complex items
        (mapcat (fn [[idx item]]
                  (make-params-internal item (str path-prefix "[" idx "]") url-encode-fn))
                (map-indexed vector data))))

    :else ; Simple value
    (if (empty? path-prefix)
      []
      [(str path-prefix "=" (url-encode-fn data))])))


(defn make-params-with-maps
  "Create a query string from a map. Handles nested maps and vectors.
  Example: {:a \"b\", :c [{:d 1} {:e 2}], :f [3 4]}
  -> \"a=b&c[0].d=1&c[1].e=2&f=3&f=4\""
  [params]
  (let [encoder (fn [v] (#_identity url-encode (str v))) ; Ensure value is stringified before encoding
        filtered-params (into {} (filter (fn [[_k v]]
                                           (or (not (vector? v)) (seq v)))
                                         params))]
    (if (empty? filtered-params)
      ""
      (clojure.string/join "&" (make-params-internal filtered-params "" encoder)))))


(deftest test-make-params-with-maps
  (is (= "ala=ma&kota=5&kota=7&kota=9&brzmi=wtrzcinie&signers[0].name=John&signers[0].email=john%40example.com&signers[1].name=Pete&signers[1].email=pete%40example.com"
         (make-params-with-maps {:ala "ma"
                                 :kota [5 7 9]
                                 :troche []
                                 :brzmi "wtrzcinie"
                                 :signers [{:name "John" :email "john@example.com"}
                                           {:name "Pete" :email "pete@example.com"}]})))
  (is (= "signers[0].name=John&signers[0].email=john%40example.com&signers[1].name=Pete&signers[1].email=pete%40example.com&kota=5&kota=7&kota=9"
         (make-params-with-maps {:signers [{:name "John" :email "john@example.com"}
                                           {:name "Pete" :email "pete@example.com"}]
                                 :kota [5 7 9]}))))
(comment
  (run-tests))

(defn bool-param [value]
  (if value "1" "0"))

(def back (handler #(.go js/history -1)))

(defn pytrue? [value]
  (cond
    (coll? value) (seq value)
    (string? value) (not-empty value)
    :else value))

(defn to-value
  "returns value, or nil if it's an empty string"
  [value]
  (if (= "" value) nil value))

(declare print-and-return)

(defn to-vector [value]
  (cond
    (nil? value) nil
    (coll? value) (when (seq value) (vec value))
    (string? value) (when (seq value) (vector value))
    :else (vector value)))

(defn date-to-rfc3339
  "converts JavaScript Date object to a string conformig to RFC 3339"
  [date]
  (->> date time-coerce/from-date (time-format/unparse (time-format/formatters :date-time))))

(defn date-from-rfc3339 [datestr]
  (time-coerce/to-date (time-format/parse (time-format/formatters :date-time) datestr)))

(defn local-date-time-to-date-string
  "Converts date time in browser's timezone to a YYYY-MM-DD date string"
  [dt]
  ;; Workaround for cljs-time using obsolete DateTime.getYear. Warning: this modifies the original JS object.
  (aset dt "getYear" (.-getFullYear dt))
  (time-format/unparse-local iso-date-formatter (time-core/from-default-time-zone dt)))

(defn ellipsis [text num-words]
  (let [text-split (clojure.string/split text #"\s+")
        ellipsis-needed (> (count text-split) num-words)]
    (if ellipsis-needed
      (str (clojure.string/join " " (take num-words text-split)) "...")
      text)))

;; https://google.github.io/closure-library/api/goog.string.linkify.html
(defn linkify [text]
  (goog-linkify/linkifyPlainTextAsHtml text nil true))

(defn sort-maps-recursively [x]
  (cond
    (map? x)
    (into (sorted-map)
          (for [[k v] x]
            [k (sort-maps-recursively v)]))

    (vector? x)
    (mapv sort-maps-recursively x)

    (seq? x)
    (map sort-maps-recursively x)

    :else x))

(defn- pprint-value-sorted [data]
  (cljs.pprint/pprint (sort-maps-recursively data)))

(defn pprint [& values]
  (doseq [val values]
    (cljs.pprint/pprint val)))

(defn pprint-sorted [& values]
  (doseq [val values]
    (pprint-value-sorted val)))

(defn log [& args]
  (apply js/console.log args))

;;When applied to a nil returns nil instead of clojure [""]
(defn split-string
  ([s re] (if (empty? s) nil (clojure.string/split s re)))
  ([s re limit] (if (empty? s) nil (clojure.string/split s re limit))))

(defn truncate [string n]
  (subs string 0 (min (count string) n)))

(defn classes [& cls]
  (clojure.string/join " " (map name (remove clojure.string/blank? cls))))

(defn- hash-query-string []
  (let [ahash (-> js/window .-location .-hash)]
    (if (clojure.string/includes? ahash "?")
      (last (clojure.string/split ahash "?"))
      "")))

(defn replace-location-query-string [query-string]
  (.replaceState js/history nil "" (str (first (clojure.string/split (-> js/window .-location .-hash) "?")) "?" query-string)))

(defn set-location-params
  ([params replace?]
   (let [url-params (if replace?
                      (js/URLSearchParams.)
                      (js/URLSearchParams. (hash-query-string)))]
     (doseq [[k v] params]
       (-> url-params (.set (name k) v)))
     (replace-location-query-string (.toString url-params))))
  ([params] (set-location-params params false)))

(defn get-location-param-vectors [location]
  (let [splitted (clojure.string/split (str location) "?")]
    (when (= 2 (count splitted))
          (reduce
           (fn [m [k v]]
             (update m (keyword k) (fn [cur] (vec (conj cur v)))))
           {}
           (js->clj
            (js/Array.from
             (js/URLSearchParams. (str "?" (last splitted)))))))))

(defn get-location-params []
  (into {} (map (fn [[k v]] [(keyword k) v]) (.from js/Array (-> (js/URLSearchParams. (hash-query-string)) .entries)))))

(defn base64-url-marshal [data] (gbase64/encodeString (pr-str data) goog.crypt.base64.Alphabet.WEBSAFE))
(defn base64-url-unmarshal [astr] (edn/read-string (gbase64/decodeString astr true)))

(defn format-number [anum]
  #_ (let [formatted (.format (NumberFormat. Format/DECIMAL) (clojure.string/trim (str anum)))]
       (if (= "NaN" formatted) anum formatted))
  (str anum))

(defn format-number-with-commas
  "Adds comma thousands separators to the integer part of a numeric string,
   e.g. 1000000 -> 1,000,000. A trailing dot is dropped (1000. -> 1,000).
   Non-numeric values are returned unchanged."
  [anum]
  (let [s (clojure.string/trim (str anum))]
    (if (re-matches #"-?\d+(\.\d*)?" s)
      (let [[int-part dec-part] (clojure.string/split s #"\." 2)
            grouped (clojure.string/replace int-part #"\B(?=(\d{3})+(?!\d))" ",")]
        (if (not-empty dec-part) (str grouped "." dec-part) grouped))
      s)))

(defn finite-decimal
  "Parses a decimal from a numeric string. Returns nil when the value does not
   read as a finite number, and nil input parses as 0 -- so a caller can tell
   absent (a valid zero) from present but unreadable."
  [value]
  (let [parsed (try
                 (dc/decimal (if (nil? value) 0 value))
                 (catch :default _ nil))]
    (when (and parsed (dc/finite? parsed))
      parsed)))

(defn unreadable-decimal?
  "True when a value is present but does not read as a finite number. An
   absent value is a valid zero, not garbage."
  [value]
  (nil? (finite-decimal value)))

(defonce ^:private reported-unreadable-decimals (atom #{}))

(defn to-decimal-or-zero
  "Like finite-decimal, but an unreadable value counts as 0. Warns once per
   distinct value, because the zero silently lowers whatever gets summed."
  [value]
  (or (finite-decimal value)
      (do
        (when-not (contains? @reported-unreadable-decimals value)
          (swap! reported-unreadable-decimals conj value)
          (warn "Value is not a finite decimal, counted as zero:" (pr-str value)))
        (dc/decimal 0))))

(defn sum-decimals
  "Sums values as decimals. An unreadable value counts as zero instead of
   throwing: AARK writes tool arguments into percentage fields unparsed. \"\"
   took the whole chat panel down from inside render (#3072), and \"100%\" did
   the same in earlier occurrences of that crash."
  [values]
  (reduce (fn [total value] (dc/plus total (to-decimal-or-zero value)))
          (dc/decimal "0")
          values))

(deftest format-number-with-commas-test
  (is (= "1,000" (format-number-with-commas "1000")))
  (is (= "1,000,000" (format-number-with-commas "1000000")))
  (is (= "1,000" (format-number-with-commas "1000.")))
  (is (= "100" (format-number-with-commas "100")))
  (is (= "-12,345.6789" (format-number-with-commas "-12345.6789")))
  (is (= "" (format-number-with-commas nil)))
  (is (= "abc" (format-number-with-commas "abc"))))

(defn print-and-return [msg value]
  (prn msg value)
  value)

(defn pprint-and-return [msg value]
  (prn msg)
  (pprint value)
  value)

(defn bracketed [text] (str "[" text "]"))

(defn apply-waypoint-params [options query-params query-params-keys]
  (merge (or options {})
         {:waypoint-params (into {}
                                 (for [[k v] (select-keys query-params query-params-keys)]
                                   [k (not-empty v)]))}))

(defn add-inactive-to-name [object]
  (if (and (contains? object :active) (not (:active object)))
    (str (:name object) " (inactive)")
    (:name object)))

(defn add-inactive-to-object-name [object]
    (assoc object :name (add-inactive-to-name object)))

(defn merge-objects [pred objects]
  (->> (map add-inactive-to-object-name objects)
       (group-by (comp clojure.string/trim pred))
       (map (fn [[name group]]
              {:id (into [] (map :id group))
               :name name}))
       (into [])
       (sort-by :name)))

(defn merge-objects-by-name [objects]
  (merge-objects :name objects))

(defn merged-object-id-str [obj]
  (str/join "," (:id obj)))

(defn merged-object-id-str-to-list [idstr]
  (when idstr (map str->int (str/split idstr ","))))

(defn merged-objects-select-value [value choice-objects]
  (let [value-id-set (set (merged-object-id-str-to-list value))]
    (merged-object-id-str
      (first
        (filter
          (fn [obj]
            (seq
              (set/intersection
                (set (:id obj))
                value-id-set)))
          choice-objects)))))

(defn deep-merge [v & vs]
  (letfn [(rec-merge [v1 v2]
            (if (and (map? v1) (map? v2))
              (merge-with deep-merge v1 v2)
              v2))]
    (if (some identity vs)
      (reduce #(rec-merge %1 %2) v vs)
      (last vs))))

(defn copy-to-clipboard [val]
  (let [el (js/document.createElement "textarea")]
    (set! (.-value el) val)
    (.appendChild js/document.body el)
    (.select el)
    (js/document.execCommand "copy")
    (.removeChild js/document.body el)))

(defn toggle-class [element-id class-to-remove class-to-add]
  (gclasslist/addRemove (gdom/getElement element-id) class-to-remove class-to-add))

(def self-updating-atom-interval-ms 2000)

(defn self-updating-atom
  "Returns an atom whose value is refreshed from (value-fn) every 2 seconds.
   With one argument a fresh reagent atom is created; with two the given
   atom is reused (it should be a reagent atom if derefed in render).

   The interval id is kept in the atom's metadata; the component that owns
   the atom MUST call stop-self-updating! on unmount or the interval leaks
   for the life of the tab (see #2884). Canonical usage:

     (reagent/with-let [a (util/self-updating-atom #(compute-ability))]
       [:div @a]
       (finally (util/stop-self-updating! a)))"
  ([value-fn] (self-updating-atom (reagent/atom nil) value-fn))
  ([iatom value-fn]
   (reset! iatom (value-fn))
   (let [interval-id (js/setInterval #(reset! iatom (value-fn)) self-updating-atom-interval-ms)]
     (alter-meta! iatom assoc ::self-updating-interval-id interval-id))
   iatom))

(defn stop-self-updating!
  "Clears the refresh interval of an atom created by self-updating-atom.
   Safe to call on plain atoms and to call more than once (no-op). Returns
   the atom."
  [iatom]
  (when-let [interval-id (::self-updating-interval-id (meta iatom))]
    (js/clearInterval interval-id)
    (alter-meta! iatom dissoc ::self-updating-interval-id))
  iatom)

(defn add-watch-with-remover
  "Adds a watch to iref (which may be a shared, long-lived atom) and returns
   a zero-arg function that removes exactly that watch. The owning component
   MUST call the remover on unmount so the watch (and everything its closure
   retains) does not outlive the component (see #2884). Canonical usage:

     (reagent/with-let [remove-fn (util/add-watch-with-remover shared-atom ::key f)]
       [:div ...]
       (finally (remove-fn)))"
  [iref key f]
  (add-watch iref key f)
  #(remove-watch iref key))

(defn distinct-by [f coll]
  (let [groups (group-by f coll)]
    (map #(first (groups %)) (distinct (map f coll)))))

(defn associate-by [f coll]
  (zipmap (map f coll) coll))

(defn uniq-by [f items]
  (:uniq (reduce (fn [acc m]
                   (let [k (f m) ]
                     (if (get-in acc [:seen k])
                       acc
                       (-> acc
                         (update :seen assoc k true)
                         (update :uniq conj m)))))
           {:seen {} :uniq []}
           items)))

;; https://groups.google.com/g/clojure-dev/c/NaAuBz6SpkY/m/_aIDyyke9b0J
(defn take-until
  "Returns a lazy sequence of successive items from coll until
   (pred item) returns true, including that item. pred must be
   free of side-effects."
  [pred coll]
  (lazy-seq
    (when-let [s (seq coll)]
      (if (pred (first s))
        (cons (first s) nil)
        (cons (first s) (take-until pred (rest s)))))))

;; Inserts <wbr/> into alphanumeric substrings longer than 8 characters
(defn html-break-text [html-str]
  (->> (str/split html-str #"(<[^>]+>)") ; Split into text and tags
       (map (fn [part]
              (if (str/starts-with? part "<")
                part ; It's a tag, return unchanged
                ;; It's text, apply original breaking logic
                (str/replace part #"\w{8,}"
                  (fn [match]
                    (clojure.string/join "<wbr/>" (re-seq #".{1,8}" match)))))))
       (str/join)))

(deftest html-break-text-test
  (testing "it breaks long words in plain text"
    (is (= "longword<wbr/>breaks" (html-break-text "longwordbreaks"))))

  (testing "it does not break text inside HTML attributes"
    (is (= "<a href=\"/some/very/long/url/that/is/unbroken\">LinkText<wbr/>IsBroken</a>"
           (html-break-text "<a href=\"/some/very/long/url/that/is/unbroken\">LinkTextIsBroken</a>"))))

  (testing "it breaks text content within tags"
    (is (= "<p>Thisisal<wbr/>ongwordt<wbr/>hatbreak<wbr/>s.</p>"
           (html-break-text "<p>Thisisalongwordthatbreaks.</p>"))))

  (testing "it handles multiple tags and text nodes correctly"
    (is (= "Textouts<wbr/>ide<p>textinsi<wbr/>de</p>moretext<wbr/>outside"
           (html-break-text "Textoutside<p>textinside</p>moretextoutside"))))

  (testing "it leaves short text and simple tags unchanged"
    (is (= "<p>Short words.</p><a href=\"/short\">link</a>"
           (html-break-text "<p>Short words.</p><a href=\"/short\">link</a>"))))

  (testing "it handles an empty string"
    (is (= "" (html-break-text "")))))

(defn kebab-to-snake [k]
  (if (keyword? k)
    (-> k name (str/replace "-" "_") keyword)
    k))

(defn snakeize-keys [m]
  (postwalk (fn [x] (if (map? x)
                      (into {} (for [[k v] x] [(kebab-to-snake k) v]))
                      x))
            m))
(defn clamp [value mn mx]
  (max mn (min value mx)))

;; Convert a hex string to an RGB map
(defn- hex-to-rgb [hex]
  (let [clean-hex (if (= (first hex) \#) (subs hex 1) hex)
        r (js/parseInt (subs clean-hex 0 2) 16)
        g (js/parseInt (subs clean-hex 2 4) 16)
        b (js/parseInt (subs clean-hex 4 6) 16)]
    {:r r :g g :b b}))

;; Convert an RGB map to a hex string
(defn- rgb-to-hex [{:keys [r g b]}]
  (str "#"
       (.padStart (.toString r 16) 2 "0")
       (.padStart (.toString g 16) 2 "0")
       (.padStart (.toString b 16) 2 "0")))

;; Function to adjust the lightness by a percentage
(defn adjust-lightness [hex percent]
  (let [{:keys [r g b]} (hex-to-rgb hex)
        factor (+ 1 (/ percent 100))
        adjust (fn [c] (clamp (Math/round (* c factor)) 0 255))]
    (rgb-to-hex {:r (adjust r) :g (adjust g) :b (adjust b)})))

;; Convert RGB to HSL
(defn rgb-to-hsl [r g b]
  (let [r' (/ r 255)
        g' (/ g 255)
        b' (/ b 255)
        max (max r' g' b')
        min (min r' g' b')
        delta (- max min)
        l (/ (+ max min) 2)
        s (if (zero? delta)
            0
            (/ delta (if (< l 0.5) (+ max min) (- 2 max min))))
        h (cond
            (zero? delta) 0
            (= max r') (mod (/ (- g' b') delta) 6)
            (= max g') (+ (/ (- b' r') delta) 2)
            :else (+ (/ (- r' g') delta) 4))]
    {:h (* 60 h)
     :s s
     :l l}))

;; Convert HSL to RGB
(defn hsl-to-rgb [h s l]
  (let [c (* (- 1 (Math/abs (- (* 2 l) 1))) s)
        x (* c (- 1 (Math/abs (mod (/ h 60) 2) 1)))
        m (- l (/ c 2))
        [r' g' b']
        (cond
          (< h 60)  [c x 0]
          (< h 120) [x c 0]
          (< h 180) [0 c x]
          (< h 240) [0 x c]
          (< h 300) [x 0 c]
          :else     [c 0 x])]
    {:r (Math/round (* 255 (+ r' m)))
     :g (Math/round (* 255 (+ g' m)))
     :b (Math/round (* 255 (+ b' m)))}))

(defn adjust-vibrancy [hex percent]
  (let [{:keys [r g b]} (hex-to-rgb hex)
        {:keys [h s l]} (rgb-to-hsl r g b)
        factor (+ 1 (/ percent 100))
        new-s (clamp (* s factor) 0 1)
        rgb (hsl-to-rgb h new-s l)]
    (rgb-to-hex rgb)))

(defn to-clj [js-value] (js->clj js-value :keywordize-keys true))

(defn ordered-group-by [f coll]
  (reduce
    (fn [ret x]
      (let [k (f x)]
        (assoc ret k (conj (get ret k []) x))))
    (linked/map) coll))

(defn add-watch-and-run [reference key no-arg-func]
  (add-watch reference key (fn [& _] (no-arg-func)))
  (no-arg-func))

(defn add-watch-new-and-run [reference key no-arg-func]
  (add-watch reference key
    (fn [_ _ oldv newv]
      (when (not= oldv newv)
        (no-arg-func))))
  (no-arg-func))

(defn add-watch-new [reference key new-value-fn]
  (add-watch reference key
    (fn [_ _ oldv newv]
      (when (not= oldv newv)
        (new-value-fn newv)))))

(defn diff-watch  [watch-fn watch-key ref old-value new-value]
  (if (not= old-value new-value)
    (do
      (debug "Watch triggered:" watch-key "| value change" (take 2 (clojure.data/diff old-value new-value)))
      (watch-fn watch-key ref old-value new-value))
    (debug "Watch triggered:" watch-key "| value unchanged, not executing")))

(defn disable-tool [options]
  (let [disabled (:disabled options)
        message (:message options)]
    [:span (merge {:class (if disabled (classes "u-fade-out" (:class options)) "")}
            (when (and disabled message)
              {:title message}))
     (:component options)]))

(defn debounce
  "Returns a debounced version of `f`. Calls to the debounced function
   wait `wait-ms` milliseconds after the last call before invoking `f`."
  [f wait-ms]
  (let [timeout-id (atom nil)]
    (fn [& args]
      ;; clear previous timer
      (when @timeout-id
        (js/clearTimeout @timeout-id))
      ;; set new timer
      (reset! timeout-id
              (js/setTimeout
                (fn [] (apply f args))
                wait-ms)))))

(defn debounce-promise
  "Debounce a function `f` that returns a promise. Returns a function
   that returns a promise that resolves with the debounced result."
  [f wait-ms]
  (let [timeout-id (atom nil)]
    (fn [& args]
      ;; clear previous timer
      (when @timeout-id
        (js/clearTimeout @timeout-id))

      ;; return a new Promesa promise
      (p/promise
        (fn [resolve reject]
          ;; schedule actual call
          (reset! timeout-id
                  (js/setTimeout
                    (fn []
                      (-> (apply f args) ;; f must return a promise
                          (p/then resolve)
                          (p/catch reject)))
                    wait-ms)))))))

(defn make-uuid [] (uuid/uuid-string (uuid/make-random-uuid)))

(defn add-uid [arg]
  (with-meta arg {:uid (make-uuid)}))

(defn string-to-boolean [value]
  (cond
    (boolean? value) value
    (string? value) (= value "true")
    :else value))

